@let myNews = news();
<ng-container *ngIf="myNews">
  <div [class.news-month]="newsEntry.type === 'heading'" [class.news-product]="newsEntry.type === 'product'" *ngFor="let newsEntry of myNews">
    <div class="news-date" *ngIf="newsEntry.type === 'heading'">{{ newsEntry.value }}</div>
    <h4 class="p-mb-3" *ngIf="newsEntry.type === 'category'">{{ newsEntry.value }}</h4>
    <h5 class="p-mb-3" *ngIf="newsEntry.type === 'product'">{{ newsEntry.value }}</h5>
    <div *ngIf="newsEntry.type === 'release_note_type'" class="release-note-type">
      <ng-container *ngIf="newsEntry.value === 'new'">
        <i class="icon-a116_star_sharp_outline"></i>
        <span>What's new</span>
      </ng-container>
      <ng-container *ngIf="newsEntry.value === 'improved'">
        <i class="icon-a184_improved"></i>
        <span>What's improved</span>
      </ng-container>
      <ng-container *ngIf="newsEntry.value === 'fixed'">
        <i class="icon-a058_bug"></i>
        <span>What's fixed</span>
      </ng-container>
    </div>
    <div *ngIf="newsEntry.type === 'release_note'" class="release-note">
      <div class="msg" [innerHTML]="newsEntry.value"></div>
    </div>

    <ng-container *ngIf="!!newsEntry?.children?.length">
      <ig-news-entry [news]="newsEntry.children"></ig-news-entry>
    </ng-container>
  </div>
</ng-container>
